import { useEffect, useState } from "react";
import { useHistory } from "react-router";
// Components
import BannerOne from "../../../components/BannerOne";
// Constants
// import { TITLE, SUB_TITLE, BUTTON_NAME , BUTTON_LINK, ALL_NEWS_LIST, ALL_EVENTS_LIST} from "./WelcomeConstants";

// Images
import homepageBanner from '../../../assets/img/partnerPortal/homepage.png';


// Scss
import '../../../assets/css/partnerProgram.scss';
import '../../../assets/css/partnerPortal/welcome.scss';


function LocatorBanner() {


  return (
    <>
      <div>
        <BannerOne bannerImage={homepageBanner} title={"Locator"} subTitle={"Check here our locator"} hasNoButton={true} />

      </div >
    </>
  );

}

export default LocatorBanner;

